import { DatePicker } from 'element-ui'

const mixinDatePicker = {
    components: {
        [DatePicker.name]: DatePicker,
    },
    data () {
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: 'Hoy',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: 'Ayer',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: 'Ultimos 7 Dias',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: 'Esta Semana',
                        onClick(picker) {
                            const current = new Date;
                            const start = new Date(current.setDate(current.getDate() - current.getDay()));
                            const end = new Date(current.setDate(current.getDate() - current.getDay()+6));
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: 'Ultima Semana',
                        onClick(picker) {
                            const current = new Date;
                            const start = new Date(current.setDate(current.getDate() - current.getDay()-7));
                            const end = new Date(current.setDate(current.getDate() - current.getDay()+6));
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: 'Este Mes',
                        onClick(picker) {
                            const current = new Date();
                            const start = new Date(current.getFullYear(), current.getMonth(), 1);
                            const end = new Date(current.getFullYear(), current.getMonth() + 1, 0);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: 'Ultimo Mes',
                        onClick(picker) {
                            const current = new Date();
                            const start = new Date(current.getFullYear(), current.getMonth() - 1, 1);
                            const end = new Date(current.getFullYear(), current.getMonth(), 0);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Este Trimestre',
                        onClick(picker) {
                            const quarters = {
                                1: [0,1,2],
                                2: [3,4,5],
                                3: [6,7,8],
                                4: [9,10,11],
                            }
                            let quarter = null;
                            const current = new Date();
                            for(const element in quarters){
                                for (let index = 0; index < quarters[element].length; index++) {
                                    if(quarters[element][index] == current.getMonth()){
                                        quarter = element
                                        break
                                    }
                                }
                                if(quarter) break
                            }
                            const start = new Date(current.getFullYear(), quarters[quarter][0], 1);
                            const end = new Date(current.getFullYear(), quarters[quarter][2] + 1, 0);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Ultimo Trimestre',
                        onClick(picker) {
                            const quarters = {
                                1: [0,1,2],
                                2: [3,4,5],
                                3: [6,7,8],
                                4: [9,10,11],
                            }
                            let quarter = null;
                            const current = new Date();
                            for(var element in quarters){
                                for (let index = 0; index < quarters[element].length; index++) {
                                    if(quarters[element][index] == current.getMonth()){
                                        if(element == 1) quarter = 4
                                        else quarter = (element - 1)
                                        break
                                    }
                                }
                                if(quarter) break
                            }
                            var start, end
                            if(quarter == 4){
                                start = new Date((current.getFullYear()-1), quarters[quarter][0], 1);
                                end = new Date((current.getFullYear()-1), quarters[quarter][2] + 1, 0);
                            } else {
                                start = new Date(current.getFullYear(), quarters[quarter][0], 1);
                                end = new Date(current.getFullYear(), quarters[quarter][2] + 1, 0);
                            }
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Este Semestre',
                        onClick(picker) {
                            const semesters = {
                                1: [0,1,2,3,4,5],
                                2: [6,7,8,9,10,11],
                            }
                            let semester = null;
                            const current = new Date();
                            for(const element in semesters){
                                for (let index = 0; index < semesters[element].length; index++) {
                                    if(semesters[element][index] == current.getMonth()){
                                        semester = element
                                        break
                                    }
                                }
                                if(semester) break
                            }
                            const start = new Date(current.getFullYear(), semesters[semester][0], 1);
                            const end = new Date(current.getFullYear(), semesters[semester][5] + 1, 0);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Ultimo Semestre',
                        onClick(picker) {
                            const semesters = {
                                1: [0,1,2,3,4,5],
                                2: [6,7,8,9,10,11],
                            }
                            let semester = null;
                            const current = new Date();
                            for(var element in semesters){
                                for (let index = 0; index < semesters[element].length; index++) {
                                    if(semesters[element][index] == current.getMonth()){
                                        if(element == 1) semester = 2
                                        else semester = 1
                                        break
                                    }
                                }
                                if(semester) break
                            }
                            var start, end
                            if(semester == 2){
                                start = new Date((current.getFullYear()-1), semesters[semester][0], 1);
                                end = new Date((current.getFullYear()-1), semesters[semester][5] + 1, 0);
                            } else {
                                start = new Date(current.getFullYear(), semesters[semester][0], 1);
                                end = new Date(current.getFullYear(), semesters[semester][5] + 1, 0);
                            }
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Este Año',
                        onClick(picker) {
                            const current = new Date();
                            const start = new Date(current.getFullYear(), 0, 1);
                            const end = new Date(current.getFullYear(), 11 + 1, 0);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Ultimo Año',
                        onClick(picker) {
                            const current = new Date();
                            const start = new Date((current.getFullYear()-1), 0, 1);
                            const end = new Date((current.getFullYear()-1), 11 + 1, 0);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            rangeDate: [new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 6), new Date()],
        }
    },
}

export default mixinDatePicker
